import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaProfileFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        gender: [
          entity && entity.gender != null ? entity.gender : 'F',
          Validators.required,
        ],
        firstName: [entity ? entity.firstName : null, Validators.required],
        otherFirstNames: [
          entity && entity.otherFirstNames ? entity.otherFirstNames : [],
        ],
        lastName: [entity ? entity.lastName : null, Validators.required],
        birthDate: [entity ? entity.birthDate : null, Validators.required],
        birthLocation: [entity ? entity.birthLocation : null],
        birthZipCode: [
          entity ? entity.birthZipCode : null,
          Validators.pattern('[0-9]{5}'),
        ],
        birthCountry: [entity ? entity.birthCountry : null],
        nationality: [entity ? entity.nationality : null, Validators.required],
        taxResidence: [
          entity && entity.taxResidence ? entity.taxResidence : 'FR',
          Validators.required,
        ],
        legalCapacity: [
          entity ? entity.legalCapacity : null,
          Validators.required,
        ],
        usResident: [entity && entity.usResident ? entity.usResident : false],
        socialSecurityNumber: [entity ? entity.socialSecurityNumber : null],
        email: [
          entity && entity.email != null
            ? entity.email
            : entity &&
                entity.contacts &&
                entity.contacts.find(c => c.type == 'EMAIL')
              ? entity.contacts.find(c => c.type == 'EMAIL').value
              : null,
          [Validators.required, Validators.email],
        ],
        mobile: [
          entity &&
          entity.contacts &&
          entity.contacts.find(c => c.type == 'TEL_MOB')?.value
            ? entity.contacts
                .find(c => c.type == 'TEL_MOB')
                .value.replace('+33', '0')
            : null,
          [Validators.required, Validators.pattern('([0-9]{2}s?){5}')],
        ],
        phone: [
          entity &&
          entity.contacts &&
          entity.contacts.find(c => c.type == 'TEL_FIX')?.value
            ? entity.contacts
                .find(c => c.type == 'TEL_FIX')
                .value.replace('+33', '0')
            : null,
          Validators.pattern('([0-9]{2}s?){5}'),
        ],
        accountId: [entity ? entity.accountId : null, Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      email: this.emptyIsNull(this.form.value.email),
      firstName: this.emptyIsNull(this.form.value.firstName),
      otherFirstNames: this.form.value.otherFirstNames || [],
      lastName: this.emptyIsNull(this.form.value.lastName),
      gender: this.emptyIsNull(this.form.value.gender),
      birthDate: new Date(this.form.value.birthDate).toISOString(),
      birthLocation: this.emptyIsNull(this.form.value.birthLocation),
      birthZipCode: this.emptyIsNull(this.form.value.birthZipCode),
      birthCountry: this.emptyIsNull(this.form.value.birthCountry),
      nationality: this.emptyIsNull(this.form.value.nationality),
      taxResidence: this.emptyIsNull(this.form.value.taxResidence),
      legalCapacity: this.emptyIsNull(this.form.value.legalCapacity),
      usResident: this.emptyIsNull(this.form.value.usResident),
      socialSecurityNumber: this.emptyIsNull(
        this.form.value.socialSecurityNumber,
      ),
      contacts: [
        {
          type: 'EMAIL',
          value: this.emptyIsNull(this.form.value.email),
          isMain: true,
          erase: !this.entity.contacts.find(c => c.type == 'EMAIL')
            ? true
            : this.form.value.email !=
                this.entity.contacts.find(c => c.type == 'EMAIL').value
              ? true
              : false,
        },
        {
          type: 'TEL_MOB',
          value: this.emptyIsNull(this.form.value.mobile)
            ? '+33' +
              String(this.emptyIsNull(this.form.value.mobile)).substring(
                1,
                this.emptyIsNull(this.form.value.mobile).length,
              )
            : null,
          isMain: true,
          erase: !this.entity.contacts.find(c => c.type == 'TEL_MOB')
            ? true
            : this.form.value.mobile !=
                this.entity.contacts.find(c => c.type == 'TEL_MOB')
              ? true
              : false,
        },
        {
          type: 'TEL_FIX',
          value: this.emptyIsNull(this.form.value.phone)
            ? '+33' +
              String(this.emptyIsNull(this.form.value.phone)).substring(
                0,
                this.emptyIsNull(this.form.value.phone).length,
              )
            : null,
          isMain: true,
          erase: !this.entity.contacts.find(c => c.type == 'TEL_FIX')
            ? true
            : this.form.value.phone !=
                this.entity.contacts.find(c => c.type == 'TEL_FIX')
              ? true
              : false,
        },
      ],
    };
    return dto;
  }
}
